import { about, defaultsOf, feature, param, ParamApply, ParamVisibility, type ConfigOf } from './registry';
import { UI_DEFAULTS, type UiConfig } from './ui-config';

// CFG-UC-1: публичные параметры сервера, которые нужны интерфейсу. Объявлены здесь, чтобы
// интерфейс знал их умолчания до ответа сервера; реестр сервера берёт эти же определения.

export const PUBLIC_SERVER_PARAMS = {
  /** CFG-UC-3: функции платформы, которые нужны интерфейсу. */
  features: {
    registration: param.bool(
      false,
      feature(
        'GR_FEATURE_REGISTRATION',
        'Свободная регистрация: посетитель сам заводит учётную запись на странице входа (IAM-UC-14)',
        'Open sign-up: visitors create their own account on the sign-in page',
        ParamVisibility.Public,
      ),
    ),
  },
  media: {
    maxUploadMb: param.int(1024, 1, 64 * 1024, {
      env: 'GR_MAX_UPLOAD_MB',
      apply: ParamApply.Live,
      visibility: ParamVisibility.Public,
      primary: true,
      about: about('Наибольший загружаемый файл (MED-UC-1)', 'Largest upload'),
    }),
  },
  demo: {
    // Только окружением: демо-режим включает защиту общего демо (ADR-014), а рабочий экземпляр
    // не должен становиться демо из настроек.
    enabled: param.bool(false, {
      env: 'GR_DEMO',
      visibility: ParamVisibility.Public,
      editable: false,
      about: about('Демо-режим: учётки на странице входа, настройки платформы только для просмотра (DEMO-UC-1, ADR-014)', 'Demo mode: accounts on the sign-in page, platform settings read-only'),
    }),
  },
};

/** Всё, что получает интерфейс: параметры интерфейса ui.* и публичные параметры сервера. */
export type PublicConfig = ConfigOf<typeof PUBLIC_SERVER_PARAMS> & { readonly ui: UiConfig };

export const PUBLIC_CONFIG_DEFAULTS: PublicConfig = { ...defaultsOf(PUBLIC_SERVER_PARAMS), ui: UI_DEFAULTS };
